<template>
    <div ::key="index">
        <!-- <v-btn v-if="loadingMore[index]" loading small class="mt-0 ml-0 ml-md-4 ml-lg-4 blue darken-4 text-white">-</v-btn> -->
        <list-more :publicationsData="morePublications[index]" @progressmore="onChangeLoading" :bo="bo"></list-more>
    </div>
</template>
<script>
import listMore from './ListMore.vue';
import {mapGetters} from 'vuex';
export default {
    props: {
        bo: {type:Boolean,
            default:false
        },
        typeProduction:{type:String},
        index:{type:Number},
    },
    data(){
        return {
            loadingMore:[],
        }
    },
    created(){
        this.loadingMore[this.index]=true;
    },
    components:{
        listMore:listMore,
    },

    computed: {
        ...mapGetters('publication',{
            morePublications:'morePublications',
            type:'type'
        }),
        ...mapGetters('header',{
            mdAndDown:'mdAndDown',
        }),
    },
    methods:{
        onChangeLoading(payload){
            this.loadingMore[this.index] = payload;
        }
    }

}
</script>


